import { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { Generico } from '../../../components/Generico';
import { FuncionarioService } from '../../../service/ficha/FuncionarioService';
import { CatalogoService } from '../../../service/CatalogoService';
import { AccGeneral } from '../../../models/fun/AccGeneral';

export const DatosAccGeneral = ({ generic, toast, id, permss, catalogos, handlePrev, next, nuevoCliente }) => {

    const omodel = new AccGeneral();
    const defaultValues = generic.default(omodel.model);
    const [ecuador, setEcuador] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues, shouldTrim: true });
    const accSrv = new FuncionarioService();
    const catalogoSrv = new CatalogoService();
    const formRef = useRef(null);
    const [bloquearCampoVinculado, setBloquearCampoVinculado] = useState(false);
    const { inDrop, inText, inCalendar, inDropMultiple, inMask } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const { stringToDate } = Generico();
    const [ciudades, setCiudades] = useState([]);

    useEffect(() => {
        editFicha();
    }, [id]);

    const onSubmit = (data) => {
        data.fecha = data.fecha.toISOString().split('T')[0];
        data.fecha_nacimiento = data.fecha_nacimiento.toISOString().split('T')[0];
        data.ec = catalogos.ecuador;
        data.casado = catalogos?.casado;
        data.seccion = 'seccion1';
        data.telefono = data.telefono?.replaceAll("_", '');

        if (id == null) {
            accSrv.nuevo(data, 'accionista-pn-bvg').then(res => {
                nuevoCliente(res.data);
                generic.funcSuccess(res, toast);
                next();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            data.id = id;
            accSrv.editar(data, 'accionista-pn-bvg').then(res => {
                nuevoCliente(res.data);
                generic.funcSuccess(res, toast);
                next();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editFicha = () => {
        accSrv.consultar(id ?? 0, 'accionista-pn-bvg', 'seccion1').then(res => {
            let _cat = catalogos;
            let _dec = res.data.acc;
            if (!_dec) {
                reset(defaultValues);
                return;
            }
            const lista = {
                pais: _cat.pais,
                tipo_proceso: _cat.tipoProceso,
                pais_residencia: _cat.pais,
                nacionalidad: _cat.nacionalidad,
                estado_civil: _cat.estado_civil,
                tipo_identificacion: _cat.tipo,
                genero: _cat.genero,
                vinculacion_tercero: generic.estadosSiNo,
                relacion_tercero: generic.estadosSiNo
            };
            if (res.data.ciudades !== undefined) {
                lista['ciudad'] = res.data.ciudades;
                lista['provincia'] = _cat.provincias;
                setCiudades(res.data.ciudades);
            }
            if (_dec.tipo_relacion) {
                _dec.tipo_relacion = _cat.tipoRelacion.filter(item => _dec.tipo_relacion.includes(item.cat_id));
            }

            Object.keys(lista).forEach(function (key) {
                if (_dec[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _dec[key]) {
                            _dec[key] = element;
                        }
                    });
                }
            });
            setEcuador(JSON.stringify(_dec.pais) === JSON.stringify(_cat.ecuador));

            if (_dec?.vid) {
                setBloquearCampoVinculado(true);
            }
            nuevoCliente({
                id: _dec?.id,
                pid: _dec?.pid,
                vid: _dec?.vid,
                hay_pep: _dec?.hay_pep,
                estado_pep: _dec?.estado_pep,
                hay_tercero: _dec?.hay_tercero,
                estado_tercero: _dec?.estado_tercero
            });

            if (_dec.fecha_nacimiento) _dec.fecha_nacimiento = stringToDate(_dec.fecha_nacimiento);
            if (_dec.fecha) _dec.fecha = stringToDate(_dec.fecha);
            reset(generic.renewValues(_dec, omodel.model));
        });
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const siguiente = () => {
        if (formRef.current) {
            formRef.current.dispatchEvent(
                new Event('submit', { bubbles: true, cancelable: true })
            );
        }
    }

    const onChangePais = (e) => {
        setEcuador(JSON.stringify(e.value) === JSON.stringify(catalogos.ecuador));
    }

    const onChangeProvincia = (e) => {
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudades(res.data);
        });
    }

    return (
        <>
            <form ref={formRef} onSubmit={handleSubmit(onSubmit, onError)}>
                <div className="formgrid grid  align-items-end">
                    {inCalendar('fecha')}
                    {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais })}
                    {ecuador && inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia })}
                    {ecuador && inDrop('ciudad', ciudades, { lab: omodel.optionLabel })}
                    {!ecuador && inText('canton')}
                    {inDrop('tipo_proceso', catalogos?.tipoProceso, { lab: omodel.optionLabel })}
                    {inDropMultiple('tipo_relacion', catalogos?.tipoRelacion, { lab: omodel.optionLabel })}
                    {inDrop('vinculacion_tercero', generic.estadosSiNo, { lab: omodel.optionLabel, ne: bloquearCampoVinculado })}
                    {inDrop('relacion_tercero', generic.estadosSiNo, { lab: omodel.optionLabel, ne: bloquearCampoVinculado })}
                </div>
                <Panel header="1 .- Datos Generales/Personales:" className="panel-ficha">
                    <div className="formgrid grid align-items-end">
                        {inText('nombres')}
                        {inText('apellidos')}
                        {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel })}
                        {inDrop('tipo_identificacion', catalogos?.tipo, { lab: omodel.optionLabel })}

                        {inText('identificacion')}
                        {inDrop('pais_residencia', catalogos?.pais, { lab: omodel.optionLabel })}
                        {inDrop('estado_civil', catalogos?.estado_civil, { lab: omodel.optionLabel })}
                        {inDrop('genero', catalogos?.genero, { lab: omodel.optionLabel })}

                        {inText('lugar_nacimiento')}
                        {inCalendar('fecha_nacimiento')}
                        {inText('direccion')}
                        {inMask('telefono')}

                        {inText('profesion')}
                        {inText('correo_electronico')}
                    </div>
                </Panel>
            </form>
            <br />

            <div className="formgrid grid">
                <div className="field col">
                    <Button label="Anterior" icon="pi pi-chevron-left" type="button" onClick={e => handlePrev()} />&nbsp;
                    <Button label="Siguiente" type="button" icon="pi pi-chevron-right" onClick={e => siguiente()} />
                </div>
            </div>
        </>
    )
}
